var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-row",
    [
      _c("el-col", { attrs: { span: 8 } }, [
        _c(
          "div",
          { staticClass: "filter-options-left" },
          [
            _vm.widget.showSwitch
              ? _c("el-switch", {
                  attrs: { "active-text": _vm.$t("panel.multiple_choice") },
                  on: { change: _vm.multipleChange },
                  model: {
                    value: _vm.attrs.multiple,
                    callback: function ($$v) {
                      _vm.$set(_vm.attrs, "multiple", $$v)
                    },
                    expression: "attrs.multiple",
                  },
                })
              : _vm._e(),
            _vm.widget.isTimeWidget && _vm.widget.isTimeWidget()
              ? _c(
                  "span",
                  { staticStyle: { "padding-left": "10px" } },
                  [
                    _c(
                      "el-checkbox",
                      {
                        on: { change: _vm.showTimeChange },
                        model: {
                          value: _vm.attrs.showTime,
                          callback: function ($$v) {
                            _vm.$set(_vm.attrs, "showTime", $$v)
                          },
                          expression: "attrs.showTime",
                        },
                      },
                      [
                        _c("span", [
                          _vm._v(_vm._s(_vm.$t("panel.show_time")) + " "),
                        ]),
                      ]
                    ),
                    _c(
                      "el-popover",
                      {
                        attrs: {
                          placement: "bottom-end",
                          disabled: !_vm.attrs.showTime,
                          width: "140",
                        },
                        model: {
                          value: _vm.timePopovervisible,
                          callback: function ($$v) {
                            _vm.timePopovervisible = $$v
                          },
                          expression: "timePopovervisible",
                        },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              width: "100%",
                              "overflow-y": "auto",
                              "overflow-x": "hidden",
                              "word-break": "break-all",
                              position: "relative",
                            },
                          },
                          [
                            _c(
                              "ul",
                              { staticClass: "de-ul" },
                              _vm._l(_vm.accuracyOptions, function (node, i) {
                                return _c(
                                  "li",
                                  {
                                    key: node.id,
                                    staticClass: "de-sort-field-span",
                                    class:
                                      _vm.attrs.accuracy === node.id
                                        ? "de-active-li"
                                        : "",
                                    attrs: { index: i },
                                    on: {
                                      click: function ($event) {
                                        _vm.attrs.accuracy = node.id
                                      },
                                    },
                                  },
                                  [_c("span", [_vm._v(_vm._s(node.name))])]
                                )
                              }),
                              0
                            ),
                          ]
                        ),
                        _c("i", {
                          staticClass: "el-icon-setting i-filter",
                          class: {
                            "i-filter-active": _vm.attrs.showTime,
                            "i-filter-inactive": !_vm.attrs.showTime,
                          },
                          attrs: { slot: "reference" },
                          slot: "reference",
                        }),
                      ]
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm.widget.isSortWidget && _vm.widget.isSortWidget()
              ? _c(
                  "span",
                  { staticStyle: { "padding-left": "10px" } },
                  [
                    _c("filter-sort", {
                      attrs: { widget: _vm.widget, element: _vm.element },
                      on: { "sort-change": _vm.sortChange },
                    }),
                  ],
                  1
                )
              : _vm._e(),
          ],
          1
        ),
      ]),
      _c("el-col", { attrs: { span: 16 } }, [
        _c("div", { staticClass: "filter-options-right" }, [
          _c(
            "span",
            { staticStyle: { "padding-right": "10px" } },
            [
              _c(
                "el-checkbox",
                {
                  on: { change: _vm.showTitleChange },
                  model: {
                    value: _vm.attrs.showTitle,
                    callback: function ($$v) {
                      _vm.$set(_vm.attrs, "showTitle", $$v)
                    },
                    expression: "attrs.showTitle",
                  },
                },
                [_vm._v(_vm._s(_vm.$t("panel.show_title")) + "\n        ")]
              ),
              _c(
                "el-popover",
                {
                  attrs: {
                    placement: "bottom-end",
                    disabled: !_vm.attrs.showTitle,
                    width: "200",
                  },
                  model: {
                    value: _vm.titlePopovervisible,
                    callback: function ($$v) {
                      _vm.titlePopovervisible = $$v
                    },
                    expression: "titlePopovervisible",
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        width: "100%",
                        "overflow-y": "auto",
                        "overflow-x": "hidden",
                        "word-break": "break-all",
                        position: "relative",
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          placeholder: _vm.$t("panel.input_title"),
                          type: "textarea",
                          maxlength: "15",
                          "show-word-limit": "",
                        },
                        model: {
                          value: _vm.attrs.title,
                          callback: function ($$v) {
                            _vm.$set(_vm.attrs, "title", $$v)
                          },
                          expression: "attrs.title",
                        },
                      }),
                    ],
                    1
                  ),
                  _c("i", {
                    staticClass: "el-icon-setting i-filter",
                    class: {
                      "i-filter-active": _vm.attrs.showTitle,
                      "i-filter-inactive": !_vm.attrs.showTitle,
                    },
                    attrs: { slot: "reference" },
                    slot: "reference",
                  }),
                ]
              ),
            ],
            1
          ),
          _c(
            "span",
            { staticStyle: { "padding-left": "10px" } },
            [
              _c(
                "el-checkbox",
                {
                  on: { change: _vm.enableRangeChange },
                  model: {
                    value: _vm.attrs.enableRange,
                    callback: function ($$v) {
                      _vm.$set(_vm.attrs, "enableRange", $$v)
                    },
                    expression: "attrs.enableRange",
                  },
                },
                [
                  _c("span", [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("panel.custom_scope")) +
                        " "
                    ),
                  ]),
                ]
              ),
              _c(
                "el-popover",
                {
                  attrs: {
                    placement: "bottom-end",
                    disabled: !_vm.attrs.enableRange,
                    width: "200",
                  },
                  model: {
                    value: _vm.popovervisible,
                    callback: function ($$v) {
                      _vm.popovervisible = $$v
                    },
                    expression: "popovervisible",
                  },
                },
                [
                  _c(
                    "div",
                    { staticClass: "view-container-class" },
                    [
                      _c(
                        "el-checkbox-group",
                        {
                          on: { change: _vm.checkedViewsChange },
                          model: {
                            value: _vm.attrs.viewIds,
                            callback: function ($$v) {
                              _vm.$set(_vm.attrs, "viewIds", $$v)
                            },
                            expression: "attrs.viewIds",
                          },
                        },
                        _vm._l(_vm.curTableViews, function (item) {
                          return _c(
                            "el-checkbox",
                            {
                              key: item.id,
                              staticClass: "de-checkbox",
                              attrs: { label: item.id },
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "span-div" },
                                [
                                  _c("svg-icon", {
                                    staticClass: "chart-icon",
                                    attrs: { "icon-class": item.type },
                                  }),
                                  item.name && item.name.length <= 7
                                    ? _c(
                                        "span",
                                        {
                                          staticStyle: { "margin-left": "6px" },
                                        },
                                        [_vm._v(_vm._s(item.name))]
                                      )
                                    : _c(
                                        "el-tooltip",
                                        {
                                          staticClass: "item",
                                          attrs: {
                                            effect: "dark",
                                            content: item.name,
                                            placement: "left",
                                          },
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticStyle: {
                                                "margin-left": "6px",
                                              },
                                            },
                                            [_vm._v(_vm._s(item.name))]
                                          ),
                                        ]
                                      ),
                                ],
                                1
                              ),
                            ]
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c("i", {
                    staticClass: "el-icon-setting i-filter",
                    class: {
                      "i-filter-active": _vm.attrs.enableRange,
                      "i-filter-inactive": !_vm.attrs.enableRange,
                    },
                    attrs: { slot: "reference" },
                    slot: "reference",
                  }),
                ]
              ),
            ],
            1
          ),
          _vm.showParams
            ? _c(
                "span",
                { staticStyle: { "padding-left": "10px" } },
                [
                  _c(
                    "el-checkbox",
                    {
                      on: { change: _vm.enableParametersChange },
                      model: {
                        value: _vm.attrs.enableParameters,
                        callback: function ($$v) {
                          _vm.$set(_vm.attrs, "enableParameters", $$v)
                        },
                        expression: "attrs.enableParameters",
                      },
                    },
                    [
                      _c("span", [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.$t("panel.binding_parameters")) +
                            " "
                        ),
                      ]),
                    ]
                  ),
                  _c(
                    "el-popover",
                    {
                      attrs: {
                        placement: "bottom-end",
                        disabled: !_vm.attrs.enableParameters,
                        width: "420",
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "view-container-class" },
                        [
                          _vm.isRangeParamWidget
                            ? _c(
                                "el-tabs",
                                {
                                  model: {
                                    value: _vm.activeName,
                                    callback: function ($$v) {
                                      _vm.activeName = $$v
                                    },
                                    expression: "activeName",
                                  },
                                },
                                _vm._l(_vm.tabsOption, function (item, index) {
                                  return _c(
                                    "el-tab-pane",
                                    {
                                      key: item.name + index,
                                      attrs: {
                                        label: item.label,
                                        name: item.name,
                                      },
                                    },
                                    [
                                      _c(
                                        "el-checkbox-group",
                                        {
                                          on: {
                                            change: function (val) {
                                              _vm.changeDynamicParams(
                                                val,
                                                item.name
                                              )
                                            },
                                          },
                                          model: {
                                            value:
                                              _vm.attrs[
                                                item.name + "Parameters"
                                              ],
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.attrs,
                                                item.name + "Parameters",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "attrs[item.name + 'Parameters']",
                                          },
                                        },
                                        _vm._l(_vm.allParams, function (ele) {
                                          return _c(
                                            "el-checkbox",
                                            {
                                              key: ele.id,
                                              staticClass: "de-checkbox",
                                              attrs: {
                                                label: ele.id,
                                                disabled:
                                                  _vm.attrs[
                                                    _vm.tabsOption[
                                                      (index + 1) % 2
                                                    ].name + "Parameters"
                                                  ] &&
                                                  _vm.attrs[
                                                    _vm.tabsOption[
                                                      (index + 1) % 2
                                                    ].name + "Parameters"
                                                  ].includes(ele.id),
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "span-div" },
                                                [
                                                  ele.alias &&
                                                  ele.alias.length <= 7
                                                    ? _c(
                                                        "span",
                                                        {
                                                          staticStyle: {
                                                            "margin-left":
                                                              "6px",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(ele.alias)
                                                          ),
                                                        ]
                                                      )
                                                    : _c(
                                                        "el-tooltip",
                                                        {
                                                          staticClass: "item",
                                                          attrs: {
                                                            effect: "dark",
                                                            content: ele.alias,
                                                            placement: "left",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticStyle: {
                                                                "margin-left":
                                                                  "6px",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  ele.alias
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                ],
                                                1
                                              ),
                                            ]
                                          )
                                        }),
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                }),
                                1
                              )
                            : _c(
                                "el-checkbox-group",
                                {
                                  model: {
                                    value: _vm.attrs.parameters,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.attrs, "parameters", $$v)
                                    },
                                    expression: "attrs.parameters",
                                  },
                                },
                                _vm._l(_vm.allParams, function (item) {
                                  return _c(
                                    "el-checkbox",
                                    {
                                      key: item.id,
                                      staticClass: "de-checkbox",
                                      attrs: { label: item.id },
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "span-div2" },
                                        [
                                          item.alias && item.alias.length <= 7
                                            ? _c(
                                                "span",
                                                {
                                                  staticStyle: {
                                                    "margin-left": "6px",
                                                  },
                                                },
                                                [_vm._v(_vm._s(item.alias))]
                                              )
                                            : _c(
                                                "el-tooltip",
                                                {
                                                  staticClass: "item",
                                                  attrs: {
                                                    effect: "dark",
                                                    content: item.alias,
                                                    placement: "left",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticStyle: {
                                                        "margin-left": "6px",
                                                      },
                                                    },
                                                    [_vm._v(_vm._s(item.alias))]
                                                  ),
                                                ]
                                              ),
                                        ],
                                        1
                                      ),
                                    ]
                                  )
                                }),
                                1
                              ),
                        ],
                        1
                      ),
                      _c("i", {
                        staticClass: "el-icon-setting i-filter",
                        class: {
                          "i-filter-active": _vm.attrs.enableParameters,
                          "i-filter-inactive": !_vm.attrs.enableParameters,
                        },
                        attrs: { slot: "reference" },
                        slot: "reference",
                      }),
                    ]
                  ),
                ],
                1
              )
            : _vm._e(),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }